import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { HEADER_DATA_SOURCE } from '../../../externals';
import { useMutation } from '@apollo/client';
import { SET_ONBOARDING_ITERATION_FREQUENCY } from './onboardingOperations';
import { logGQLErrors } from '../../../shared/logGQLErrors';
export var useSetOnboardingIterationFrequency = function useSetOnboardingIterationFrequency() {
  var _useMutation = useMutation(SET_ONBOARDING_ITERATION_FREQUENCY, {
    context: _defineProperty({}, HEADER_DATA_SOURCE, true),
    onError: function onError(error) {
      return logGQLErrors('Header - Set onboarding iteration frequency failed', error);
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      setOnboardingIterationFrequency = _useMutation2[0];

  return setOnboardingIterationFrequency;
};